import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async get() {
        try{                
            const response = await axios.get(`MyAttendance`, {
                headers: {
                    'page_key': pageKeys.my_attendance
                }
            })             
            return response
        }catch (error){
            console.log('axios MyAttendance get error: ' + error)
            throw error
        }
    },
    async getDaily(dt) {
        try{                
            const response = await axios.get(`MyAttendance/${dt}`, {
                headers: {
                    'page_key': pageKeys.my_attendance
                }
            })             
            return response
        }catch (error){
            console.log('axios MyAttendance getDaily error: ' + error)
            throw error
        }
    },
    async getPastWeek() {
        try{                
            const response = await axios.get(`MyAttendance/week`, {
                headers: {
                    'page_key': pageKeys.my_attendance
                }
            })             
            return response
        }catch (error){
            console.log('axios MyAttendance getPastWeek error: ' + error)
            throw error
        }
    },
    async clockIn(data) {
        try{            
            const response = await axios.post(`MyAttendance/clockin`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.my_attendance
                }
            })            
            return response
        }catch (error){
            console.log('axios clockIn error: ' + error)
            throw error
        }
    },
    async clockOut(data) {
        try{            
            const response = await axios.post(`MyAttendance/clockout`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.my_attendance
                }
            }
            )            
            return response
        }catch (error){
            console.log('axios clockOut error: ' + error)
            throw error
        }
    },
    async deleteAttendancePic(data) {
        try
        {            
            const response = await axios.post(`MyAttendance/delete/attendance/pic`, {
                image: data
            },
            {
                headers: {
                    'page_key': pageKeys.my_attendance
                }
            });
            
            return response;
        }
        catch (error)
        {
            console.log('deleteAttendancePic error')
            throw error
        }
    }
}